module.exports = __webpack_public_path__ + "static/media/banner_audi_mid.4c57d0e4.jpg";